import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    breadcrumbs: {
        marginBottom: 24,
        marginLeft: 4
    }
});
